import React, { ComponentPropsWithoutRef, forwardRef } from "react"

import { Group, SelectItem, Space, Text } from "@mantine/core"
import { IconSunrise, IconSunset } from "@tabler/icons-react"

import { WittyPiSchedule } from "../../hooks/useParseSchedule"
import { useLanguage } from "../../../../contexts/language-context"

export type PresetSelectItemProps = ComponentPropsWithoutRef<"div"> & Partial<WittyPiSchedule> & SelectItem

const PresetSelectItem = forwardRef<HTMLDivElement, PresetSelectItemProps>(
    ({ label, lines, dayPattern, ...rest }, ref) => {
        const { L } = useLanguage()

        return (
            <div ref={ref} {...rest}>
                <Text size="sm">{label}</Text>
                <Text size="xs" color="dimmed">
                    <Group spacing="0.5rem" noWrap>
                        {lines?.map(line =>
                            line.start && line.end ? (
                                <>
                                    {line.start.slice(0, 5)} – {line.end.slice(0, 5)}
                                    <Space w="0.25rem" />
                                </>
                            ) : line.preBuffer && line.postBuffer ? (
                                <>
                                    {L("-%s min", line.preBuffer)}
                                    {line.type === "sunrise" ? <IconSunrise size={18} /> : <IconSunset size={18} />}
                                    {L("+%s min", line.postBuffer)}
                                    <Space w="0.25rem" />
                                </>
                            ) : null,
                        )}
                        {dayPattern?.length &&
                            L(
                                "at %s",
                                dayPattern
                                    .reduce<string[]>(
                                        (acc, day, index) =>
                                            day
                                                ? [
                                                      ...acc,
                                                      [
                                                          L("Monday"),
                                                          L("Tuesday"),
                                                          L("Wednesday"),
                                                          L("Thursday"),
                                                          L("Friday"),
                                                          L("Saturday"),
                                                          L("Sunday"),
                                                      ][index],
                                                  ]
                                                : acc,
                                        [],
                                    )
                                    .join(", "),
                            )}
                    </Group>
                </Text>
            </div>
        )
    },
)

export default PresetSelectItem
